function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23",
  height: "19",
  viewBox: "0 0 23 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.387 17.306a1 1 0 100-2v2zm0-2h-1.48v2h1.48v-2zm-1.48 0A3.907 3.907 0 012 11.4H0a5.907 5.907 0 005.907 5.907v-2zm0-9.814A5.907 5.907 0 000 11.399h2a3.907 3.907 0 013.907-3.907v-2zM15.06 15.306a1 1 0 000 2v-2zm1.48 0h-1.48v2h1.48v-2zm3.907-3.907a3.907 3.907 0 01-3.907 3.907v2a5.907 5.907 0 005.907-5.907h-2zM16.54 7.492a3.907 3.907 0 013.907 3.907h2a5.907 5.907 0 00-5.907-5.907v2z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.553 6.477v0A5.477 5.477 0 0012.076 1h-1.34a5.842 5.842 0 00-5.841 5.842v0",
  stroke: "#12002D",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.146 12.655l-2.892-2.892-2.892 2.892",
  stroke: "#12002D",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.223 17.76a1 1 0 102 0h-2zm0-7.588v7.588h2v-7.588h-2z",
  fill: "#12002D"
})));